<template>
  <div>
      <div class="" style="margin-bottom: 83px;">
            <div class="TSDN-title">关于亚马逊SHIPTRACK</div>
            <div class="TSDN-content">
              为了帮助广大的中国卖家在亚马逊平台更好地经营，亚马逊在2023年8月底针对中国卖家发出了一条公告，可以为中国卖家的FBA货件提供更加精准的物流追踪服务，对于没有使用官方合作承运商的中国FBA卖家，可以考虑选择参与ShipTrack计划的承运商，这些承运商会自动在卖家中心更新点对点的物流追踪信息。
            </div>
        </div>
  </div>
</template>
<script>


/**
* Index-1 component
*/
export default {
components: {

},
data(){
  return {
      
  }
},
methods: {
 
}
};
</script>
<style src="./componentsIndex.css" scoped>

</style>